import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Map, TrendingUp, Ship } from 'lucide-react';

// Importando as imagens locais
import mapa2010 from "../../assets/img/mapas/mapa2010.png";
import mapa2024 from "../../assets/img/mapas/mapa2024.png";

export default function ArcoNorteSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Desenvolvimento Estratégico do Arco Norte
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A consolidação de um novo corredor logístico para o agronegócio brasileiro.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 items-center">
          {/* Texto */}
          <div className="space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <TrendingUp className="w-5 h-5 text-green-600" /> Uma Revolução Logística
                </CardTitle>
              </CardHeader>
              <CardContent className="text-gray-700">
                <p>
                  Até o início da década passada, a exportação de grãos era quase totalmente
                  dependente dos portos do Sul e Sudeste. O Arco Norte, que abrange portos e
                  hidrovias do Amazonas ao Nordeste, emergiu como uma alternativa competitiva,
                  transformando a logística nacional.
                </p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <Ship className="w-5 h-5 text-blue-600" /> Fatores do Sucesso
                </CardTitle>
              </CardHeader>
              <CardContent className="text-gray-700 space-y-2">
                <p>
                  O crescimento foi impulsionado por investimentos chave em infraestrutura multimodal: a <strong>pavimentação da BR-163</strong>, a <strong>expansão da Ferrovia Norte-Sul</strong> e, crucialmente, a <strong>Lei dos Portos (12.815/2013)</strong>, que permitiu a construção de novos Terminais de Uso Privado (TUPs).
                </p>
                <p>
                  Essa combinação reduziu custos e tempo de transporte para os produtores do Centro-Oeste, tornando o agronegócio brasileiro ainda mais competitivo no mercado global.
                </p>
              </CardContent>
            </Card>
            <Card>
              <CardHeader>
                <CardTitle className="flex items-center gap-2 text-lg">
                  <Map className="w-5 h-5 text-orange-600" /> Números de Destaque
                </CardTitle>
              </CardHeader>
              <CardContent className="text-gray-700 space-y-2">
                <p>
                  Em 2024, o Arco Norte foi responsável por <strong>35% de toda a exportação</strong> do Brasil. A movimentação de soja e milho na região saltou de volumes inexpressivos em 2010 para mais de <strong>52 milhões de toneladas</strong> em 2024, com destaque para os portos do Pará e Maranhão.
                </p>
              </CardContent>
            </Card>
          </div>

  {/* Imagens */}
<div>
  <div className="flex flex-col items-center gap-12">
    <div className="w-full max-w-3xl text-center">
      <img
        src={mapa2010}
        alt="Mapa das exportações em 2010"
        className="rounded-lg shadow-xl w-full h-auto border-4 border-white"
      />
      <p className="text-sm text-gray-600 mt-2">Exportações em 2010</p>
    </div>

    <div className="w-full max-w-3xl text-center">
      <img
        src={mapa2024}
        alt="Mapa das exportações em 2024"
        className="rounded-lg shadow-xl w-full h-auto border-4 border-white"
      />
      <p className="text-sm text-gray-600 mt-2">Exportações em 2024</p>
    </div>
  </div>

  {/* Legenda geral */}
  <p className="text-xs text-center text-gray-500 mt-6">
    Fonte: INFRA S.A. com dados da ANTAQ. Comparativo da exportação de milho e soja em 2010 e 2024.
  </p>
</div>

        </div>
      </div>
    </section>
  );
}
